"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = require("lodash");

var _tableTreeGenerate = _interopRequireDefault(require("./table/tableTreeGenerate"));

var _relation = _interopRequireDefault(require("./relation"));

var _getRequester = _interopRequireDefault(require("./requester/getRequester"));

var _editRequester = _interopRequireDefault(require("./requester/editRequester"));

var _deleteRequester = _interopRequireDefault(require("./requester/deleteRequester"));

var _copyRequester = _interopRequireDefault(require("./requester/copyRequester"));

var _dataStore = _interopRequireDefault(require("./dataStore"));

var _common = require("./utils/common");

var _wrapData = require("./wrapData");

var _constant = require("./constant");

var _menu = require("./utils/menu");

/**
 * 数据源管理类
 */
var DataManager = /*#__PURE__*/function () {
  function DataManager(options) {
    (0, _classCallCheck2["default"])(this, DataManager);
    console.info('dataManager init options', options); // 每个表的扩展配置（目前主要用于删除时的逻辑控制）

    this.extendTableInfo = options.extendTableInfo || {}; // 用于生成一致的schema树，uicore渲染数据树要要用

    this.selectedSchema = options.selectedSchema; // 配置的表关系集

    this.relation = new _relation["default"](options.relationData);
    _dataStore["default"].envHost = options.envHost || '';
    _dataStore["default"].projectId = options.projectid || '';
    _dataStore["default"].pageId = options.pageId || '';
    _dataStore["default"].env = options.env || '';
    _dataStore["default"].mode = options.mode || '';
    _dataStore["default"].fetchQuery = options.fetchQuery || {};
  }
  /**
   * 获取主表的单条关联数据
   * @param {*} options dataManager统一的入参对象
   */


  (0, _createClass2["default"])(DataManager, [{
    key: "getDetail",
    value: function () {
      var _getDetail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(options) {
        var uuid, tableTreeObj, requester, detailResult, fieldList, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uuid = (0, _common.generateUUID)();
                _context.prev = 1;
                console.info("dataManager[".concat(uuid, "] getDetail options"), options);

                if (options.objectId) {
                  _context.next = 5;
                  break;
                }

                throw Error("dataManager[".concat(uuid, "] getDetail options.objectId is undefined"));

              case 5:
                _context.next = 7;
                return (0, _tableTreeGenerate["default"])(options, this.relation, this.extendTableInfo);

              case 7:
                tableTreeObj = _context.sent;
                requester = new _getRequester["default"](tableTreeObj, uuid);
                _context.next = 11;
                return requester.getAllDataDetail(options.objectId);

              case 11:
                detailResult = _context.sent;

                if (!(requester.errMsg.length > 0)) {
                  _context.next = 15;
                  break;
                }

                console.error("dataManager[".concat(uuid, "] getDetail error"), requester.errMsg);
                return _context.abrupt("return", {
                  code: -1,
                  message: 'error',
                  errorData: requester.errMsg
                });

              case 15:
                (0, _wrapData.fixDataPrefix)(detailResult, tableTreeObj.tableTree);
                (0, _wrapData.mergeDataByOneToOne)(detailResult, tableTreeObj.tableTree);
                _context.next = 19;
                return _dataStore["default"].getSchemaByTableKeys([options.mainTable].concat(options.forkTableList || []));

              case 19:
                fieldList = _context.sent;
                result = {
                  code: 200,
                  message: 'success',
                  data: {
                    fieldList: (0, _wrapData.fixSchemaPrefix)(fieldList),
                    dataDetail: detailResult[0]
                  }
                };
                console.info("dataManager[".concat(uuid, "] getDetail success"), result);
                return _context.abrupt("return", result);

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](1);
                console.error("dataManager[".concat(uuid, "] getDetail error"), _context.t0);
                return _context.abrupt("return", {
                  code: _context.t0.code || -1,
                  message: _context.t0.message,
                  errorData: _context.t0
                });

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 25]]);
      }));

      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }

      return getDetail;
    }()
    /**
     * 获取主表的批量关联数据
     * @param {*} options dataManager统一的入参对象
     */

  }, {
    key: "getList",
    value: function () {
      var _getList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(options) {
        var uuid, tableTreeObj, requester, listResult, fieldList, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                uuid = (0, _common.generateUUID)();
                _context2.prev = 1;
                console.info("dataManager[".concat(uuid, "] getList options"), options); // 拿到一个完整的table树，能提前有的数据都有了

                _context2.next = 5;
                return (0, _tableTreeGenerate["default"])(options, this.relation, this.extendTableInfo);

              case 5:
                tableTreeObj = _context2.sent;
                requester = new _getRequester["default"](tableTreeObj, uuid);
                _context2.next = 9;
                return requester.getAllDataList();

              case 9:
                listResult = _context2.sent;

                if (!(requester.errMsg.length > 0)) {
                  _context2.next = 13;
                  break;
                }

                console.error("dataManager[".concat(uuid, "] getList error"), requester.errMsg);
                return _context2.abrupt("return", {
                  code: -1,
                  message: 'error',
                  errorData: requester.errMsg
                });

              case 13:
                (0, _wrapData.fixDataPrefix)(listResult.dataList, tableTreeObj.tableTree);
                (0, _wrapData.mergeDataByOneToOne)(listResult.dataList, tableTreeObj.tableTree);
                _context2.next = 17;
                return _dataStore["default"].getSchemaByTableKeys([options.mainTable].concat(options.forkTableList || []));

              case 17:
                fieldList = _context2.sent;
                result = {
                  code: 200,
                  message: 'success',
                  data: {
                    fieldList: (0, _wrapData.fixSchemaPrefix)(fieldList),
                    dataList: listResult.dataList,
                    dataCount: listResult.dataCount
                  }
                };
                console.info("dataManager[".concat(uuid, "] getList success"), result);
                return _context2.abrupt("return", result);

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](1);
                console.error("dataManager[".concat(uuid, "] getList error"), _context2.t0);
                return _context2.abrupt("return", {
                  code: _context2.t0.code || -1,
                  message: _context2.t0.message,
                  errorData: _context2.t0
                });

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 23]]);
      }));

      function getList(_x2) {
        return _getList.apply(this, arguments);
      }

      return getList;
    }()
    /**
     * 编辑主表的关联数据（单条 or 批量）
     * @param {*} options dataManager统一的入参对象
     * @param {*} type 操作类型
     * @param {*} $newList 新的数据(Object or Array)
     * @param {*} $oldList 旧的数据(Object or Array)
     */

  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(options, type, $newList, $oldList) {
        var funcName,
            uuid,
            newList,
            oldList,
            tableTreeObj,
            requester,
            primaryKey,
            mainTable,
            id,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                funcName = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : 'updateDetail';
                uuid = (0, _common.generateUUID)();
                newList = $newList;
                oldList = $oldList;
                _context3.prev = 4;
                console.info("dataManager[".concat(uuid, "] ").concat(funcName, " options"), {
                  options: options,
                  type: type,
                  newList: newList,
                  oldList: oldList
                }); // 拿到一个完整的table树，能提前有的数据都有了

                _context3.next = 8;
                return (0, _tableTreeGenerate["default"])(options, this.relation, this.extendTableInfo);

              case 8:
                tableTreeObj = _context3.sent;
                oldList = this.reversalDataList(oldList, tableTreeObj.tableTree);
                newList = this.reversalDataList(newList, tableTreeObj.tableTree);

                if (!(type === 'create')) {
                  _context3.next = 21;
                  break;
                }

                if (newList) {
                  _context3.next = 14;
                  break;
                }

                throw Error('type === "create", newList must exist');

              case 14:
                if (!oldList) {
                  _context3.next = 16;
                  break;
                }

                throw Error('type === "create", oldList must not exist');

              case 16:
                requester = new _editRequester["default"](tableTreeObj, uuid);
                _context3.next = 19;
                return requester.editAllDataDetail(newList);

              case 19:
                _context3.next = 49;
                break;

              case 21:
                if (!(type === 'edit')) {
                  _context3.next = 31;
                  break;
                }

                if (!(!newList || !oldList)) {
                  _context3.next = 24;
                  break;
                }

                throw Error('type === "edit", both newList and oldList must exist');

              case 24:
                // 强校验：edit时，不允许主表的数据被删除
                primaryKey = tableTreeObj.tableTree.primaryKey;
                oldList.forEach(function (oldData) {
                  if (!oldData[primaryKey] || !newList.find(function (newData) {
                    return newData[primaryKey] === oldData[primaryKey];
                  })) {
                    throw Error('type === "edit", oldList does not allow deleted data');
                  }
                });
                requester = new _editRequester["default"](tableTreeObj, uuid);
                _context3.next = 29;
                return requester.editAllDataDetail(newList, oldList);

              case 29:
                _context3.next = 49;
                break;

              case 31:
                if (!(type === 'delete')) {
                  _context3.next = 41;
                  break;
                }

                if (!newList) {
                  _context3.next = 34;
                  break;
                }

                throw Error('type === "delete", newList must not exist');

              case 34:
                if (oldList) {
                  _context3.next = 36;
                  break;
                }

                throw Error('type === "delete", oldList must exist');

              case 36:
                requester = new _deleteRequester["default"](tableTreeObj, uuid);
                _context3.next = 39;
                return requester.deleteAllDataDetail(oldList, options.objectId);

              case 39:
                _context3.next = 49;
                break;

              case 41:
                if (!(type === 'copy')) {
                  _context3.next = 49;
                  break;
                }

                if (newList) {
                  _context3.next = 44;
                  break;
                }

                throw Error('type === "copy", newList must exist');

              case 44:
                if (!oldList) {
                  _context3.next = 46;
                  break;
                }

                throw Error('type === "copy", oldList must not exist');

              case 46:
                requester = new _copyRequester["default"](tableTreeObj, uuid);
                _context3.next = 49;
                return requester.copyAllDataDetail(newList);

              case 49:
                if (!(requester.errMsg.length > 0)) {
                  _context3.next = 52;
                  break;
                }

                console.error("dataManager[".concat(uuid, "] ").concat(funcName, " error"), requester.errMsg);
                return _context3.abrupt("return", {
                  code: -1,
                  message: 'error',
                  errorData: requester.errMsg
                });

              case 52:
                console.info("dataManager[".concat(uuid, "] updateDetail success")); // 人工是单条的新增，则返回主键给可视化跳转用

                if (!(type === 'create' || type === 'copy')) {
                  _context3.next = 58;
                  break;
                }

                mainTable = tableTreeObj.tableTree;
                id = -1;

                if (mainTable.dataList.length > 0) {
                  id = mainTable.dataList[0][mainTable.primaryKey] || -1;
                }

                return _context3.abrupt("return", {
                  code: 200,
                  message: 'success',
                  data: {
                    id: id
                  }
                });

              case 58:
                return _context3.abrupt("return", {
                  code: 200,
                  message: 'success'
                });

              case 61:
                _context3.prev = 61;
                _context3.t0 = _context3["catch"](4);
                console.error("dataManager[".concat(uuid, "] ").concat(funcName, " error"), _context3.t0);
                return _context3.abrupt("return", {
                  code: _context3.t0.code || -1,
                  message: _context3.t0.message,
                  errorData: _context3.t0
                });

              case 65:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 61]]);
      }));

      function updateDetail(_x3, _x4, _x5, _x6) {
        return _updateDetail.apply(this, arguments);
      }

      return updateDetail;
    }()
    /**
     * 编辑主表的关联数据(提供给外部单条、批量两种接口，后期好扩展)
     */

  }, {
    key: "updateList",
    value: function () {
      var _updateList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(options, newList, oldList) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.updateDetail(options, 'edit', newList, oldList, 'updateList');

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateList(_x7, _x8, _x9) {
        return _updateList.apply(this, arguments);
      }

      return updateList;
    }()
    /**
     * 还原用户传入的数据结构，转成tableTree能理解的数据
     * @param {*} $dataList
     * @param {*} tableTree
     */

  }, {
    key: "reversalDataList",
    value: function reversalDataList($dataList, tableTree) {
      var dataList = $dataList;

      if (dataList) {
        if (dataList instanceof Array) {
          dataList = (0, _lodash.cloneDeep)(dataList);
        } else {
          dataList = (0, _lodash.cloneDeep)([dataList]);
        }

        (0, _wrapData.reversalMergeDataByOneToOne)(dataList, tableTree);
        (0, _wrapData.reversalFixDataPrefix)(dataList, tableTree);
      }

      return dataList;
    }
    /**
     * 获取递归后的dataSchema
     */

  }, {
    key: "getDataSchema",
    value: function () {
      var _getDataSchema = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(options) {
        var tableTreeObj, result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return (0, _tableTreeGenerate["default"])(options, this.relation, this.extendTableInfo);

              case 3:
                tableTreeObj = _context5.sent;
                result = this.schemaTreeGenerate(tableTreeObj.tableTree);
                return _context5.abrupt("return", {
                  code: 200,
                  message: 'success',
                  data: result
                });

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                console.error('dataManager getDataSchema error', _context5.t0);
                return _context5.abrupt("return", {
                  code: _context5.t0.code || -1,
                  message: _context5.t0.message,
                  errorData: _context5.t0
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));

      function getDataSchema(_x10) {
        return _getDataSchema.apply(this, arguments);
      }

      return getDataSchema;
    }()
    /**
     * 对应数据树的schema树的生成，uicore渲染表单要用
     * @param {*} table
     * @param {*} parentRelationObj
     * @param {*} parentDataSchemaObj
     */

  }, {
    key: "schemaTreeGenerate",
    value: function schemaTreeGenerate(table, parentRelationObj, parentDataSchemaObj) {
      var that = this;
      var findSchemaObj = that.selectedSchema.find(function (item) {
        return "".concat(item.appId, ".").concat(item.schemaId) === table.key;
      });

      if (findSchemaObj) {
        var dataSchemaObj = (0, _lodash.cloneDeep)(findSchemaObj.dataSchema);
        dataSchemaObj.table = table.key;
        dataSchemaObj.fields.forEach(function ($item) {
          var item = $item;
          item.table = "".concat(findSchemaObj.appId, ".").concat(findSchemaObj.schemaId);
          item.title = item.title || item.id;
          item.id = "".concat(findSchemaObj.appId).concat(_constant.SPLIT).concat(findSchemaObj.schemaId).concat(_constant.SPLIT).concat(item.id);
        });
        var nextParentDataSchemaObj = dataSchemaObj; // 非根节点的才走这个逻辑

        if (parentRelationObj && parentDataSchemaObj) {
          // 一对一、普通的一对n但n是父节点、link的一对n但n是父节点
          if (parentRelationObj.ratio === '1' || parentRelationObj.ratio === '2' && (parentRelationObj.relation[1] === _menu.RelationStatus.LEFT || parentRelationObj.relation[1] === _menu.RelationStatus.IN)) {
            dataSchemaObj.fields.forEach(function (item) {
              parentDataSchemaObj.fields.push(item);
            });
            nextParentDataSchemaObj = parentDataSchemaObj;
          } else {
            parentDataSchemaObj.fields.push({
              id: "".concat(findSchemaObj.appId).concat(_constant.SPLIT).concat(findSchemaObj.schemaId),
              type: 'array',
              title: String(findSchemaObj.tableCName).replace(/\s/g, ''),
              table: "".concat(findSchemaObj.appId, ".").concat(findSchemaObj.schemaId),
              items: dataSchemaObj,
              isForkTable: true
            });
          }
        }

        if (table.forkTableList.length > 0) {
          table.forkTableList.forEach(function (forkTableObj) {
            var forkTable = forkTableObj.forkTable,
                relationObj = forkTableObj.relationObj;
            that.schemaTreeGenerate(forkTable, relationObj, nextParentDataSchemaObj);
          });
        }

        return dataSchemaObj;
      }
    }
  }]);
  return DataManager;
}();

var _default = DataManager;
exports["default"] = _default;